import React, { useEffect, useRef, useState } from 'react';
import {
    Divider,
    Empty,
    Input,
    message,
    Spin,
    Typography,
} from 'antd';
import InfiniteScroll from 'react-infinite-scroll-component';
import ProfileAvatar from '../../modules/candidate/components/profil-avatar';
import {
    asCurrentProject,
    changePage,
    projectsList,
    projectsState,
    setCurrentProject,
} from '../../modules/projects/projects.slice';
import { useDispatch, useSelector } from 'react-redux';
import { loginState } from '../../modules/login/login.slice';
import { debounce } from 'lodash';

const { Text } = Typography;

const ProjectDropdown = ({ setOpen, open, triggerRef }) => {
    const dispatch = useDispatch();
    const [page, setPage] = useState(0);
    const [projectDisable, setProjectDisable] = useState(false);
    const [projectData, setProjectData] = useState([]);
    const { status, projects, isNext, pageLimit } = useSelector(projectsState);
    const { userProfile } = useSelector(loginState);

    const dropdownRef = useRef(null);

    useEffect(() => {
        if (open) {
            dispatch(projectsList({ limit: 10, skip: 0 }));
            setPage(0);
        }
    }, [open]);

    useEffect(() => {
        if (Array.isArray(projects)) {
            if (page === 0) {
                setProjectData(projects);
            } else {
                setProjectData((prev) => [...prev, ...projects]);
            }
        }
        // else {
        //     console.warn("⚠️ projects is not an array:", projects);
        // }
    }, [projects]);



    useEffect(() => {
        function handleClickOutside(event) {
            const isOutsideDropdown = dropdownRef.current && !dropdownRef.current.contains(event.target);
            const isOutsideTrigger = triggerRef?.current && !triggerRef.current.contains(event.target);

            if (isOutsideDropdown && isOutsideTrigger) {
                setOpen(false);
            }
        }

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [setOpen, triggerRef])

    const fetchMoreProjects = () => {
        if (isNext && status !== 'loading') {
            const nextPage = page + 1;
            dispatch(projectsList({ limit: 10, skip: nextPage * 10 }));
            setPage(nextPage);
        }
    };

    const currentProject = async (id, name) => {
        setProjectDisable(true);
        const result = await dispatch(
            asCurrentProject({
                id,
                project: { isActive: true },
            })
        );

        const data = result?.payload?.data;

        if (data?.success) {
            localStorage.setItem('currentProject', JSON.stringify({ id, name }));
            dispatch(
                changePage({
                    currentPage: 1,
                    skip: 0,
                    pageLimit,
                })
            );
            localStorage.setItem('currentSprint', JSON.stringify({}));
            message.success(data.message);

            setTimeout(() => {
                setProjectDisable(false);
                window.location.reload();
            }, 1000);
        } else {
            setProjectDisable(false);
            message.error(data?.message || 'Something went wrong, try again later.');
        }

        dispatch(setCurrentProject({ id, name }));
    };

    const searchFn = debounce((value) => {
        dispatch(projectsList({ search: value }));
        setPage(0);
    }, 800);

    return (
        <div>
            {open && (
                <div
                    ref={dropdownRef}
                    style={{
                        boxShadow: 'rgba(0, 0, 0, 0.05) 0px 0px 0px 1px',
                        marginTop: 10,
                        backgroundColor: '#231e43',
                        borderRadius: '8px',
                        position: 'absolute',
                        zIndex: 1,
                        padding: '10px',
                        left: '0px',
                        margin: '0 5px',
                        width: '247px',
                        top: '84px',
                    }}
                >
                    <Input
                        placeholder="Search..."
                        size="large"
                        style={{ marginTop: '5px' }}
                        onChange={(e) => searchFn(e.target.value)}
                    />
                    <Divider style={{ margin: '10px' }} />
                    <Spin spinning={status === 'loading' && page === 0 || projectDisable}>
                        {projectData?.length === 0 ? (
                            <Empty description="No Project Found" />
                        ) : (
                            <InfiniteScroll
                                dataLength={projectData.length}
                                next={fetchMoreProjects}
                                hasMore={isNext}
                                loader={<div style={{ textAlign: 'center', padding: '10px' }}><Spin /></div>}
                                height={300}
                            // endMessage={
                            //     <div style={{ textAlign: 'center', padding: '10px', color: '#aaa' }}>
                            //         <Text type="secondary">No more projects</Text>
                            //     </div>
                            // }
                            >
                                {projectData.map((project) => (
                                    <div
                                        key={project._id}
                                        onClick={() => {
                                            if (
                                                userProfile?.activeProject?._id !== project?._id &&
                                                !projectDisable
                                            ) {
                                                currentProject(project._id, project.name);
                                            }
                                        }}
                                        style={{
                                            padding: '8px 12px',
                                            borderRadius: 4,
                                            color: 'white',
                                            backgroundColor:
                                                userProfile?.activeProject?._id === project._id
                                                    ? '#080f2d'
                                                    : 'transparent',
                                            cursor: 'pointer',
                                            marginBottom: 4,
                                            transition: 'all 0.2s',
                                        }}
                                    >
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <div style={{ marginRight: '8px' }}>
                                                <ProfileAvatar
                                                    profilePicture={project?.projectProfile}
                                                    name={project?.name}
                                                />
                                            </div>
                                            {project?.name}
                                        </div>
                                    </div>
                                ))}
                            </InfiniteScroll>
                        )}
                    </Spin>
                </div>
            )}
        </div>
    );
};

export default ProjectDropdown;
